// extracted by mini-css-extract-plugin
export default {"secondary":"commonBtn_secondary__YlKaa","primary":"commonBtn_primary__fP6nT","green":"commonBtn_green__gnLnR","red":"commonBtn_red__HGIlw"};